import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from '@material-ui/core/CircularProgress';


// core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";

import avatar from "assets/img/default-avatar.png";

import lockScreenPageStyle from "assets/jss/material-dashboard-pro-react/views/lockScreenPageStyle.jsx";
import { loginReset, loginRequest } from "../../actions/loginPage";

class LockScreenPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      password: '',
      error: {},
    };
  }
  componentWillMount() {
    if (!this.props.loginData.AuthData) {
      this.props.history.replace('/');
    }
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  componentDidUpdate() {
    if (this.props.loginData.success) {
      this.props.dispatch(loginReset())
      this.props.history.replace('/admin/dashboard', null);
    }
  }

  handleTextChange(field, event) {
    const { value } = event.target
    this.setState({ [field]: value, passwordError: false, emailError: false });
  }

  login() {
    const { AuthData } = this.props.loginData;
    const payload = {
      email: AuthData.user.email,
      password: this.state.password,
    }

    this.props.dispatch(loginRequest(payload));

  }

  render() {
    const { classes } = this.props;
    const { AuthData } = this.props.loginData;
    const user = AuthData ? AuthData.user : {};
    return (
      <div className={classes.container}>
        <Snackbar
          place="tc"
          color="danger"
          message="Invalid Credentials, password is incorrect"
          open={!!this.props.loginData.errors}
          closeNotification={() => this.props.dispatch(loginReset())}
          close
        />
        <form>
          <Card
            profile
            className={
              classes.customCardClass + " " + classes[this.state.cardAnimaton]
            }
          >
            <CardAvatar profile className={classes.cardAvatar}>
              <img src={avatar} alt="..." />
            </CardAvatar>
            <CardBody profile>
              <h4 className={classes.cardTitle}>{user.firstName} {user.lastName}</h4>
              <CustomInput
                labelText="Enter Password"
                id="company-disabled"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  type: "password",
                  onChange: this.handleTextChange.bind(this, 'password'),
                  value: this.state.password,

                }}
              />
            </CardBody>
            <CardFooter className={classes.justifyContentCenter}>
              {
                this.props.loginData.loader ?
                  (<CircularProgress />) :
                  (
                    <Button onClick={() => this.login()} color="info" round>
                      Unlock
                    </Button>
                  )
              }
            </CardFooter>
            <br />
          </Card>
        </form>
      </div>
    );
  }
}

LockScreenPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(lockScreenPageStyle)(
  connect(state => ({ loginData: state.loginState }))(LockScreenPage)
);
